import { Volume2, Delete, X, Save } from "lucide-react";
import { t } from "@/lib/i18n";

export default function SentenceStrip({
  items,
  onSpeak,
  onBackspace,
  onClear,
  onRemoveAt,
  onSaveAsTile,
  speaking,
  lang = "en",
}) {
  const empty = items.length === 0;

  return (
    <div
      className="brutal-card p-3 sm:p-4 flex items-stretch gap-3"
      data-testid="sentence-strip"
    >
      <div
        className="flex-1 min-h-[96px] sm:min-h-[112px] rounded-2xl border-[3px] border-[color:var(--ink)] bg-[color:var(--paper-muted)] px-3 py-2 flex items-center gap-2 overflow-x-auto tile-scroll"
        data-testid="sentence-strip-track"
      >
        {empty ? (
          <span className="text-[color:var(--ink-soft)] italic px-2 select-none">
            {t(lang, "strip.placeholder")}
          </span>
        ) : (
          items.map((it, idx) => (
            <button
              type="button"
              key={`${it.id}-${idx}`}
              onClick={() => onRemoveAt && onRemoveAt(idx)}
              className="strip-tile relative shrink-0 bg-white border-[3px] border-[color:var(--ink)] rounded-xl px-2 py-2 flex flex-col items-center justify-center min-w-[78px] min-h-[78px] sm:min-w-[88px] sm:min-h-[88px] shadow-[3px_3px_0_0_var(--ink)]"
              style={{ background: it.color || "#fff" }}
              aria-label={`Remove ${it.label}`}
              data-testid={`strip-item-${idx}`}
            >
              {it.custom_image_b64 ? (
                <img src={it.custom_image_b64} alt="" className="w-12 h-12 object-cover rounded-lg border-2 border-[color:var(--ink)]" />
              ) : (
                <span className="text-3xl leading-none" aria-hidden>{it.emoji}</span>
              )}
              <span className="text-xs sm:text-sm font-semibold mt-1 text-center text-[color:var(--ink)]" style={{fontFamily:"Lexend"}}>{it.label}</span>
            </button>
          ))
        )}
      </div>

      <div className="flex flex-col gap-2 justify-between">
        <button
          type="button"
          className="pill-btn"
          onClick={onBackspace}
          disabled={empty}
          aria-label="Backspace"
          data-testid="strip-backspace"
        >
          <Delete size={18} />
          <span className="hidden sm:inline">{t(lang, "strip.back")}</span>
        </button>
        <button
          type="button"
          className="pill-btn danger"
          onClick={onClear}
          disabled={empty}
          aria-label="Clear sentence"
          data-testid="strip-clear"
        >
          <X size={18} />
          <span className="hidden sm:inline">{t(lang, "strip.clear")}</span>
        </button>
        {onSaveAsTile && (
          <button
            type="button"
            className="pill-btn gold"
            onClick={onSaveAsTile}
            disabled={items.length < 2}
            aria-label="Save sentence as tile"
            title="Save this sentence as a one-tap tile"
            data-testid="strip-save-tile"
          >
            <Save size={18} />
            <span className="hidden sm:inline">Save tile</span>
          </button>
        )}
        <button
          type="button"
          className={`pill-btn primary ${speaking ? "speaking" : ""}`}
          onClick={onSpeak}
          disabled={empty}
          aria-label="Speak sentence"
          data-testid="strip-speak"
        >
          <Volume2 size={20} />
          <span>{t(lang, "strip.speak")}</span>
        </button>
      </div>
    </div>
  );
}
